module.exports = __webpack_public_path__ + "static/events-7fc48fcf597160a3077485c933a3b8b2.svg";